import React, {useContext} from 'react';
import {Link, useLocation, withRouter} from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import HelpInfo from '../../components/HelpInfo';
import 'react-tabs/style/react-tabs.css';
import './landing.scss';
import CampaignDialog from '../../components/CampaignDialog';
import {StoreContext} from "../../store/context";
import {Field, Form, Formik} from "formik";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const Landing = (props) => {
  const { state, actions } = useContext(StoreContext);
  const { showAppBar } = state.generalStates;
  const { username, password } = state.authStates;
  const { displayAppBar } = actions.generalActions;
  const { login } = actions.authActions;
  const [open, setOpen] = React.useState(true);

  return (
    <div className="page-container">
        <div className="landing">
            <img className="logoImg" src="/images/qin_logo.png"/>
            <Formik
                initialValues={{
                    username: `${username ? username : ''}`,
                    password: `${password ? password : ''}`,
                }}
                onSubmit={(values, { setSubmitting }) => {
                    login(values, props.history);
                    setSubmitting(false);
                }}>
                {({ isSubmitting }) => (
                    <Form className="landing-form">
                        <div className="username-field">
                            <Field name="username">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field} label="Username" variant="outlined" className="text-input"/>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="password-field">
                            <Field name="password">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field} label="Password" variant="outlined" type="password" className="text-input"/>
                                    </>
                                )}
                            </Field>
                        </div>

                        <div className="password-field">
                            {/* default submit button will fire  "onSubmit" function when clicked */}
                            <Button variant="contained" type="submit" color="primary" disabled={isSubmitting} className="submit-button">
                                Login
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </div>
  )
};

export default withRouter(Landing)
